export enum MessageSendingStatus {
	Pending = 10,
	Processing = 20,
	Sent = 30,
	Failed = 0
}